import React, {useEffect, useState} from "react";
import "./NewsPublicPages.css";
import {apiGetNews} from "../api/news";
import NewsCard from "../components/NewsCard";

const GENERIC_ERROR_MESSAGE = "Impossible d'afficher les actualités pour le moment.";

export default function NewsListPage({onBack}) {
    const [page, setPage] = useState(1);
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        setLoading(true);
        apiGetNews({page, limit: 9}).then(data => {
            if (data?.error) {
                // safeJson (api/news.js) renvoie {error: "<message ami>"} sans champ `message`
                // sur un échec réseau/parsing réel — ce message est une constante côté client,
                // jamais contrôlée par le backend, donc sûre à afficher telle quelle.
                // Toute réponse portant un champ `message` vient du backend (ex. l'erreur 500
                // {error: "SERVER_ERROR", message: err.message}) et ne doit jamais être affichée brute.
                setError(data.message === undefined ? data.error : GENERIC_ERROR_MESSAGE);
                setResult(null);
                setLoading(false);
                return;
            }
            setError("");
            setResult(data);
            setLoading(false);
        });
    }, [page]);

    const items = result && Array.isArray(result.items) ? result.items : [];
    const totalPages = result?.totalPages || 1;

    return (
        <div className="news-public-page">
            <div className="news-public-wrap">
                {onBack && (
                    <button className="news-public-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>
                )}

                <h1 className="news-public-title">Actualités</h1>

                {loading && <p className="news-public-status">Chargement…</p>}

                {!loading && error && (
                    <p className="news-public-status">{error}</p>
                )}

                {!loading && !error && items.length === 0 && (
                    <p className="news-public-status">Aucune actualité publiée pour le moment.</p>
                )}

                {!loading && !error && items.length > 0 && (
                    <>
                        <div className="news-grid">
                            {items.map(article => <NewsCard key={article.slug} article={article}/>)}
                        </div>

                        {totalPages > 1 && (
                            <div className="news-public-pagination">
                                <button onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={page <= 1}>
                                    ← Précédent
                                </button>
                                <span>Page {page} / {totalPages}</span>
                                <button onClick={() => setPage(p => Math.min(p + 1, totalPages))} disabled={page >= totalPages}>
                                    Suivant →
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
